module.exports = __webpack_public_path__ + "img/nether_ancient_small.abdc615a.png";